import { RootState } from 'rootReducer';

export const weigthSelector = (state: RootState) => state.commonReducer.weightScalesReducer;
